export const groupBy = (array, key) =>
    array.reduce((result, currentValue) => {
        const found = result.find((item) => item[key] === currentValue[key]);
        if (!found) {
            result.push(currentValue);
        }
        return result;
    }, []);
